function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_643",
  "data-name": "Group 643",
  transform: "translate(-1131 -375)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_24",
  "data-name": "Ellipse 24",
  cx: 21,
  cy: 21,
  r: 21,
  transform: "translate(1131 375)",
  fill: "#eeeff3"
}), /*#__PURE__*/React.createElement("g", {
  id: "access_time_filled_black_24dp",
  transform: "translate(1139.555 384)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_467",
  "data-name": "Group 467"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_128",
  "data-name": "Path 128",
  d: "M0,0H24V24H0Z",
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_468",
  "data-name": "Group 468",
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_129",
  "data-name": "Path 129",
  d: "M11.99,2A10,10,0,1,0,22,12,10,10,0,0,0,11.99,2ZM16,16a1,1,0,0,1-1.41,0L11.3,12.71A1,1,0,0,1,11,12V8a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1v3.59l3,3A1,1,0,0,1,16,16Z",
  transform: "translate(-2 -2)",
  fill: "#f6b900"
}))));

var SvgDuration = function SvgDuration(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDuration, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/duration.106e2afa.svg";
export { ForwardRef as ReactComponent };